import { render, staticRenderFns } from "./AllocationResult.vue?vue&type=template&id=45e36546&scoped=true&"
import script from "./AllocationResult.vue?vue&type=script&lang=js&"
export * from "./AllocationResult.vue?vue&type=script&lang=js&"
import style0 from "./AllocationResult.vue?vue&type=style&index=0&id=45e36546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e36546",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VDataTable,VDialog,VIcon,VList,VMenu,VSelect})
